import { render, staticRenderFns } from "./callback-add-or-update.vue?vue&type=template&id=231b8326&scoped=true&"
import script from "./callback-add-or-update.vue?vue&type=script&lang=js&"
export * from "./callback-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./callback-add-or-update.vue?vue&type=style&index=0&id=231b8326&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231b8326",
  null
  
)

export default component.exports